import { stringify } from 'query-string';
export const fetchHierarchies = async ({ placesIds, bffUri, }) => {
    const requestUrl = new URL([bffUri, 'places/hierarchy'].join(''));
    requestUrl.search = stringify({ placesIds });
    try {
        const response = await fetch(requestUrl.toString(), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            },
            signal: AbortSignal.timeout(3000),
        });
        if (response.ok) {
            return await response.json();
        }
    }
    catch {
        return undefined;
    }
    return undefined;
};
